module.exports = __webpack_public_path__ + "static/media/source_location .19054aac.svg";